(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw ((a.code = "MODULE_NOT_FOUND"), a);
        }
        var p = (n[i] = { exports: {} });
        e[i][0].call(
          p.exports,
          function (r) {
            var n = e[i][1][r];
            return o(n || r);
          },
          p,
          p.exports,
          r,
          e,
          n,
          t
        );
      }
      return n[i].exports;
    }
    for (
      var u = "function" == typeof require && require, i = 0;
      i < t.length;
      i++
    )
      o(t[i]);
    return o;
  }
  return r;
})()(
  {
    1: [
      function (require, module, exports) {
        "use strict";

        var _burgerMenu = _interopRequireDefault(
          require("./temp-modules/burger-menu")
        );
        var _accordion = _interopRequireDefault(
          require("./temp-modules/accordion")
        );
        var _tabs = _interopRequireDefault(require("./temp-modules/tabs"));
        var _slider = _interopRequireDefault(require("./temp-modules/slider"));
        function _interopRequireDefault(e) {
          return e && e.__esModule ? e : { default: e };
        }
        // You can write a call and import your functions in this file.
        //
        // This file will be compiled into app.js and will not be minified.
        // Feel free with using ES6 here.

        (function ($) {
          // When DOM is ready
          $(function () {
            _accordion["default"].init();
            _burgerMenu["default"].init();
            _tabs["default"].init();
            _slider["default"].init();
          });
        })(jQuery);
      },
      {
        "./temp-modules/accordion": 2,
        "./temp-modules/burger-menu": 3,
        "./temp-modules/slider": 4,
        "./temp-modules/tabs": 5,
      },
    ],
    2: [
      function (require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = void 0;
        var CLASS_TITLE = "accordion__title";
        var CLASS_CONTENT = "accordion__content";
        var CLASS_ACTIVE = "active";
        var CLASS_ACCORDION_ALL = "accordion_all";
        var ACCORDION = document.getElementsByClassName("accordion");
        var accordion = (function () {
          var accordionInit = function accordionInit() {
            var _loop = function _loop() {
              var contentAccordion =
                ACCORDION[item].getElementsByClassName(CLASS_CONTENT);
              var titleAccordion =
                ACCORDION[item].getElementsByClassName(CLASS_TITLE);
              if (ACCORDION[item].classList.contains(CLASS_ACCORDION_ALL)) {
                var showAllAccordion = function showAllAccordion(toggle) {
                  var currentAccordion = document.getElementById(toggle);
                  currentAccordion.classList.toggle(CLASS_ACTIVE);
                };
                for (var i = 0; i < titleAccordion.length; i += 1) {
                  titleAccordion[i].addEventListener("click", function () {
                    showAllAccordion(this.dataset.accordion);
                    this.classList.toggle(CLASS_ACTIVE);
                  });
                }
              } else {
                var showAccordion = function showAccordion(toggle) {
                  var currentAccordion = document.getElementById(toggle);
                  if (currentAccordion.classList.contains(CLASS_ACTIVE)) {
                    currentAccordion.classList.remove(CLASS_ACTIVE);
                  } else {
                    for (var _i = 0; _i < contentAccordion.length; _i += 1) {
                      contentAccordion[_i].classList.remove(CLASS_ACTIVE);
                    }
                    currentAccordion.classList.add(CLASS_ACTIVE);
                  }
                };
                for (var _i2 = 0; _i2 < titleAccordion.length; _i2 += 1) {
                  titleAccordion[_i2].addEventListener(
                    "click",
                    function (_ref) {
                      var target = _ref.target;
                      var clickedElement = target.closest(
                        ".".concat(CLASS_TITLE)
                      );
                      if (clickedElement) {
                        showAccordion(clickedElement.dataset.accordion);
                        if (clickedElement.classList.contains(CLASS_ACTIVE)) {
                          clickedElement.classList.remove(CLASS_ACTIVE);
                        } else {
                          for (var j = 0; j < titleAccordion.length; j += 1) {
                            titleAccordion[j].classList.remove(CLASS_ACTIVE);
                          }
                          clickedElement.classList.add(CLASS_ACTIVE);
                        }
                      }
                    }
                  );
                }
              }
            };
            for (var item = 0; item < ACCORDION.length; item += 1) {
              _loop();
            }
          };
          var init = function init() {
            if (ACCORDION.length > 0) {
              accordionInit();
            }
          };
          return {
            init: init,
          };
        })();
        var _default = (exports["default"] = accordion);
      },
      {},
    ],
    3: [
      function (require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = void 0;
        var burgerMenu = (function () {
          var BURGER = document.querySelectorAll(".js-burger");
          var NAV = document.querySelector(".js-nav");
          var BODY = document.querySelector("body");
          var OVERFLOW = "overflow";
          var ACTIVE = "active";
          var burgerFunc = function burgerFunc() {
            BURGER.forEach(function (item) {
              item.addEventListener("click", function () {
                item.classList.toggle(ACTIVE);
                NAV.classList.toggle(ACTIVE);
                BODY.classList.toggle(OVERFLOW);
              });
            });
          };
          var init = function init() {
            burgerFunc();
          };
          return {
            init: init,
          };
        })();
        var _default = (exports["default"] = burgerMenu);
      },
      {},
    ],
    4: [
      function (require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = void 0;
        var swiperSlider = (function () {
          var accountantInit = new Swiper(".story-cards-mobile-slider", {
            slidesPerView: 2.3,
            spaceBetween: 16,
            speed: 300,
          });
          var designInit = new Swiper(".product-design-mobile", {
            slidesPerView: 2,
            spaceBetween: 16,
            speed: 300,
          });
          var init = function init() {};
          return {
            init: init,
          };
        })();
        var _default = (exports["default"] = swiperSlider);
      },
      {},
    ],
    5: [
      function (require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = void 0;
        var ACTIVE = "active";
        var tabs = (function () {
          var tabsUnit = function tabsUnit() {
            var TAB = document.querySelectorAll(".js-tabs-btn");
            for (var i = 0; TAB.length > i; i += 1) {
              var currentTab = TAB[i];
              currentTab.addEventListener("click", function (e) {
                for (var y = 0; TAB.length > y; y += 1) {
                  var _currentTab = TAB[y];
                  var currentTabContent = document.querySelector(
                    ".".concat(_currentTab.getAttribute("data-tab"))
                  );
                  _currentTab.classList.remove(ACTIVE);
                  currentTabContent.classList.remove(ACTIVE);
                }
                e.currentTarget.classList.add(ACTIVE);
                var target = e.currentTarget.getAttribute("data-tab");
                var targetContent = document.querySelector(".".concat(target));
                targetContent.classList.add(ACTIVE);
              });
            }
          };
          var init = function init() {
            tabsUnit();
          };
          return {
            init: init,
          };
        })();
        var _default = (exports["default"] = tabs);

        const wrapper = document.querySelector(".product-button-wrapper");
        const desktopBtn = document.querySelector(".product-button-desktop");

        const checkScreenSize = () =>
          window.matchMedia("(max-width: 1023px)").matches;

        if (!wrapper || !desktopBtn) return;

        const handleIntersection = () => {
          const isSmallScreen = checkScreenSize();
          if (!isSmallScreen) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                desktopBtn.classList.remove("fixed");
              } else {
                desktopBtn.classList.add("fixed");
              }
            });
          });

          observer.observe(wrapper);
        };

        handleIntersection();

        window.addEventListener("resize", () => {
          if (!checkScreenSize()) {
            desktopBtn.classList.remove("fixed");
          } else {
            handleIntersection();
          }
        });
      },
      {},
    ],
  },
  {},
  [1]
);
